// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import LocationInput from '../location';

const LocationInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  className,
  fullWidth,
}) => {
  return (
    <LocationInput label={label} className={className} fullWidth={fullWidth} />
  );
};

export default LocationInputWithAnalytics;
